/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  SeasonRewardsYear1,
  SeasonRewardsYear1Interface,
} from "../SeasonRewardsYear1";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "rewardsFactory_",
        type: "address",
      },
      {
        internalType: "address",
        name: "seasons_",
        type: "address",
      },
      {
        internalType: "address",
        name: "pearlStore_",
        type: "address",
      },
      {
        internalType: "address",
        name: "pearlToken_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "migrationSeasonIndex_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "oracle_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "Ownable_NewOwnerCannotBeAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "Ownable_SenderIsNotOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_CannotConfigureSeasonRewardsAfterMigration",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_InvalidConfig",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_InvalidConfigIndex",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_InvalidPosition",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_InvalidYearForSeason",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_NoRewards",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_OnlySeasonsContractCanCall",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_SeasonAlreadyOver",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_SharesOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_TokenIsNotInConfig",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_YearAlreadyOver",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_ZeroShareIsNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "Rewards_ZeroTokenAmountIsNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferHelper_TransferError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "share",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
    ],
    name: "AddPositionForSeason",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
    ],
    name: "AddSeasonRewardsConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DecrementSeasonRewardsConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seasonYear",
        type: "uint256",
      },
    ],
    name: "JackpotRewardsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "SeasonRewardsClaimed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "tokens",
        type: "bytes32[]",
      },
    ],
    name: "addJackpotNFTTokensPerPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenRates",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "roundValues",
        type: "uint256[]",
      },
    ],
    name: "addJackpotRewardsERC20Tokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "tokens",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "maxUSDTAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[][]",
        name: "positionShares",
        type: "uint256[][]",
      },
      {
        internalType: "bytes32[][]",
        name: "nftTokens",
        type: "bytes32[][]",
      },
    ],
    name: "addNewConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "positions",
        type: "uint256[]",
      },
      {
        internalType: "address[][]",
        name: "tokens",
        type: "address[][]",
      },
      {
        internalType: "uint256[][]",
        name: "shares",
        type: "uint256[][]",
      },
    ],
    name: "addPositionsForSeason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "addSeasonRewardsConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "changeSeason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimJackpotRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "claimSeasonRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "configBySeason",
    outputs: [
      {
        internalType: "uint256",
        name: "configIndex",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deleteSeasonRewardsConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "configIndex",
        type: "uint256",
      },
    ],
    name: "getConfig",
    outputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenRates",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "maxUSDTAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "getJackpotNFTTokensPerPosition",
    outputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "metadataLimits",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "getJackpotPositionRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[]",
        name: "rewards",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionFrom",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "positionTo",
        type: "uint256",
      },
    ],
    name: "getJackpotRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[][]",
        name: "rewards",
        type: "tuple[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getJackpotRewardsERC20Tokens",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenRate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "roundValue",
            type: "uint256",
          },
        ],
        internalType: "struct IRewards.JackpotRewardsERC20Token[]",
        name: "result",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getJackpotRewardsPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "result",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getJackpotRewardsPositionsCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getJackpotRewardsSharesPerPosition",
    outputs: [
      {
        internalType: "uint256[]",
        name: "result",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLatestConfigIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "configIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "getSeasonConfigForPosition",
    outputs: [
      {
        internalType: "uint256[]",
        name: "positionShares",
        type: "uint256[]",
      },
      {
        internalType: "address[]",
        name: "nftTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "nftMetadataLimits",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "getSeasonPositionRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[]",
        name: "rewards",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "positionFrom",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "positionTo",
        type: "uint256",
      },
    ],
    name: "getSeasonRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[][]",
        name: "rewards",
        type: "tuple[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "getSeasonRewardsConfig",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "distributedAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "distributedShares",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.RewardsConfig[]",
        name: "rewards",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
    ],
    name: "getSeasonRewardsPositionsCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSeasonYear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUserJackpotPositionRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[]",
        name: "rewards",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUserSeasonPositionRewards",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
        ],
        internalType: "struct IRewards.PositionRewards[]",
        name: "rewards",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonYear_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "isJackpotPositionClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "result",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "isSeasonPositionClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "position",
        type: "uint256",
      },
    ],
    name: "jackpotCanBeClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "result",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPearlSalesForJackpot",
    outputs: [
      {
        internalType: "uint256",
        name: "result",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "migrationSeasonIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pearlStore",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pearlToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "seasonsContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seasonIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "configIndex",
        type: "uint256",
      },
    ],
    name: "setConfigToSeason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "percentage",
        type: "uint256",
      },
    ],
    name: "setJackpotRewardsPercentage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "shares",
        type: "uint256[]",
      },
    ],
    name: "setJackpotRewardsSharesPerPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setLatestPearlSales",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class SeasonRewardsYear1__factory {
  static readonly abi = _abi;
  static createInterface(): SeasonRewardsYear1Interface {
    return new Interface(_abi) as SeasonRewardsYear1Interface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): SeasonRewardsYear1 {
    return new Contract(address, _abi, runner) as unknown as SeasonRewardsYear1;
  }
}
